import { render, staticRenderFns } from "./teachingActivity.vue?vue&type=template&id=5ceae32c&scoped=true"
import script from "./teachingActivity.vue?vue&type=script&lang=js"
export * from "./teachingActivity.vue?vue&type=script&lang=js"
import style0 from "./teachingActivity.vue?vue&type=style&index=0&id=5ceae32c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ceae32c",
  null
  
)

export default component.exports